export const supportEmail = "charsmithapp@gmail.com";
export const patreonLink =
  "https://patreon.com/charsmith?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink";
export const purchaseLink =
  "https://felixisaacs.itch.io/pico-hogwild-playtest-pre-gens";

export const stableLink = "https://wildsea-charsmith-stable.netlify.app";
